/* global System */
// register component(s) with react habitat

export default {
  SprintRaceImageSlider: () =>
    System.import(
      /* webpackChunkName: "SprintRaceImageSlider" */
      './SprintRaceImageSlider'
    ),
}
